import React from 'react';
import PropTypes from 'prop-types';

const Pane = ({ children }) => (
  <div className="tabs-pane">
    {children}
  </div>
);

Pane.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.element
  ])
};

export default Pane;



// WEBPACK FOOTER //
// ./src/components/common/ui/tabs/Pane.jsx